import List from "@mui/material/List";
import MuiDrawer from "@mui/material/Drawer";
import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";
import { useContext, useEffect, useState } from "react";
import IconConfig from "../../icons/config";
import ModalManual from "../../modalManual";
import { useNavigate } from "react-router-dom";
import React from "react";
import { Box } from "@mui/system";
import Logout from "@mui/icons-material/Logout";
import { AuthContext } from "../../../contexts/AuthContext";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import ListItemSys from "./listItem";
import AvatarItem from "./avataItem";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import HelpHeader from "../../../components/generic/appBarHeader/helpHeader";
import HomeIcon from "@mui/icons-material/Home";
import MenuConfig from "./menuConfig";
import { Tooltip } from "@mui/material";

const drawerWidth = 240;

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => {
  return {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    borderRadius: "1rem",
    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme),
    }),
  };
});

const openedMixin = (theme) => ({
  width: drawerWidth,
  background: "#aceaff !important",
  borderRight: "none !important",
  borderTopRightRadius: "0.8rem",
  borderBottomRightRadius: "0.8rem",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});
var duration = 0;

const closedMixin = (theme) => {
  duration = theme.transitions.duration.leavingScreen;
  return {
    background: "#00a7e1 !important",
    borderRight: "none !important",
    borderTopRightRadius: "0.8rem",
    borderBottomRightRadius: "0.8rem",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
      width: `calc(${theme.spacing(8)} + 1px)`,
    },
  };
};

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

export default function DrawerAside({
  open,
  handleDrawerClose,
  handleDrawerOpen,
  name,
}) {
  const navigate = useNavigate();
  const theme = useTheme();
  const initState = open;
  const [openHeader, setOpenHeader] = useState(open);
  const { signOut } = useContext(AuthContext);
  const [moduleActive, setModuleActive] = useState(name);
  const [oldName, setOldName] = useState("Home");
  const { user } = useContext(AuthContext);
  const [modal, setModal] = useState(false);
  const permissionDashboard = [];
  const permissionConfig = [];

  user?.permission?.map((el) => {
    if (el.name == "Dashboard") {
      permissionDashboard.push(...el.permission);
    }
    if(el.name == "Config") {
      permissionConfig.push(...el.permission);
    }
  });

  useEffect(() => {
    setModuleActive(name);
  }, [name]);

  const [edit, setEdit] = useState(true);

  useEffect(() => {
    setOpenHeader(open);
  }, [open]);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(false);
  };

  const handleMenu = (e) => {
    if (e.target.className == "MuiBox-root css-1vtiz46") {
      if (!initState) {
        handleDrawerOpen();
      } else {
        handleDrawerClose();
      }
    }
  };

  return (
    <>
      <Drawer
        id="menu-lateral"
        variant="permanent"
        open={open}
        sx={{ backgroundColor: "#000 !important" }}
        onClick={handleMenu}

      // onMouseLeave={!initState ? () => { handleDrawerOpen() } : () => { handleDrawerClose() }}
      >
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <List
              onClick={() => {
                navigate("/home");
                setModuleActive("Home");
              }}
              sx={{ zIndex: (theme) => theme.zIndex.tooltip + 1 }}
            >
              <ListItemSys
                moduleActive={moduleActive}
                icon={
                  <AvatarItem
                    text={"Home"}
                    moduleActive={moduleActive}
                    openHeader={openHeader}
                  >
                    <Tooltip title="Início">
                      <HomeIcon />
                    </Tooltip>
                  </AvatarItem>
                }
                openHeader={openHeader}
                text={"Home"}
              ></ListItemSys>
            </List>
            {!!permissionDashboard.find((el) => el.name == "Visualizar") ? (
              <List
                onClick={() => {
                  navigate("/dashboard");
                  setModuleActive("Dashboard");
                }}
              >
                <ListItemSys
                  moduleActive={moduleActive}
                  icon={
                    <AvatarItem
                      text={"Dashboard"}
                      moduleActive={moduleActive}
                      openHeader={openHeader}
                    >
                      <Tooltip title="Dashboard">
                        <AnalyticsIcon />
                      </Tooltip>
                    </AvatarItem>
                  }
                  openHeader={openHeader}
                  text={"Dashboard"}
                ></ListItemSys>
              </List>
            ) : null}
            <List
              onClick={() => {
                navigate("/profile");
                setModuleActive("Perfil");
              }}
            >
              {/* <ListItemSys icon={<PersonIcon sx={{ color: "#2B3A8B" }} />} openHeader={openHeader} text={"Perfil"}>
            </ListItemSys> */}
              {/* <ListItemSys icon={<AvatarItem text={"Perfil"} moduleActive={moduleActive} openHeader={openHeader} >
              <PersonIcon />
            </AvatarItem>} moduleActive={moduleActive} openHeader={openHeader} text={"Perfil"}>
            </ListItemSys> */}
            </List>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {permissionConfig.find((el) => el.name == "Visualizar")
            ? (
              <List
                id="basic-button"
                aria-controls={!!anchorEl ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={!!anchorEl ? "true" : undefined}
                onClick={
                  !!anchorEl
                    ? () => { }
                    : (e) => {
                      setOldName(moduleActive);
                      setModuleActive("Configurações");
                      handleClick(e);
                    }
                }
              >
                
                <ListItemSys
                  icon={
                    <AvatarItem
                      text={"Configurações"}
                      moduleActive={moduleActive}
                      openHeader={openHeader}
                    >
                      <Tooltip title="Configuraçães">
                        <IconConfig />
                      </Tooltip>
                    </AvatarItem>
                  }
                  moduleActive={moduleActive}
                  openHeader={openHeader}
                  text={"Configurações"}
                ></ListItemSys>
                {!!anchorEl && (
                  <div>
                    <MenuConfig
                      anchorEl={anchorEl}
                      openHeader={openHeader}
                      open={!!anchorEl}
                      onClose={() => {
                        setModuleActive(oldName);
                        handleClose();
                      }}
                      handleClose={handleClose}
                    ></MenuConfig>
                  </div>
                )}
              </List>
            ) : null}
            <List onClick={() => {setModal(true);  }} sx={{ marginBottom: "32px" }}>
              <ListItemSys
                icon={
                  <AvatarItem
                    text={"Ajuda"}
                    moduleActive={moduleActive}
                    openHeader={openHeader}
                  >
                    <Tooltip title="Ajuda">
                      <QuestionMarkIcon />
                    </Tooltip>
                  </AvatarItem>
                }
                moduleActive={moduleActive}
                openHeader={openHeader}
                text={"Ajuda"}
              ></ListItemSys>
            </List>
             {/* <HelpHeader
            onClick={() => {setModal(true);  }}
            ></HelpHeader> */}
            <List onClick={() => signOut()}>
              <ListItemSys
                icon={
                  <Tooltip title="Sair"><Logout sx={{ color: "#2B3A8B" }} /></Tooltip>}
                openHeader={openHeader}
                text={"Sair"}
              ></ListItemSys>
            </List>
          </Box>
        </Box>
      </Drawer>

      <ModalManual
        imageUrls={[]}
        open={modal}
        handleClose={() => setModal(false)}
      ></ModalManual></>
  );
}
